import DropdownItem, { DropdownItemProps } from 'components/atoms/item/DropdownItem';
import NestedDropdownItem, { NestedDropdownItemProps } from 'components/atoms/item/NestedDropdownItem';
import React, { forwardRef, PropsWithChildren } from 'react';
import { DropdownMenu as Wrapper } from './styles';
import { useTranslation } from 'react-i18next';

export interface DropdownMenuProps {
    items: ((close?: () => void) => DropdownItemProps[]) | DropdownItemProps[];
    onSubItemClick?: (value: string | number | boolean) => void;
    access?: boolean;
    close?: () => void;
    width?: number;
}

const DropdownMenu = forwardRef<HTMLUListElement, PropsWithChildren<DropdownMenuProps>>(
    ({ items: initialItems, children, onSubItemClick, close, width, ...props }, ref) => {
        const { t } = useTranslation();
        // Render.
        const items = (typeof initialItems === 'function' ? initialItems(close) : initialItems).filter((item) => item.access !== false);

        return (
            <Wrapper ref={ref} width={width} {...props}>
                {items.length ? (items.map((item) => {
                    const isNested = item.items ? item.items.length > 0 : false;

                    if (isNested) {
                        return (
                            <NestedDropdownItem
                                key={item.title}
                                {...(item as NestedDropdownItemProps)}
                                onSubItemClick={onSubItemClick}
                                onSubSubItemClick={item.onSubItemClick}
                            />
                        );
                    } else {
                        return <DropdownItem key={item.title} {...item} close={close} onSubItemClick={onSubItemClick} />;
                    }
                })) : (
                    <DropdownItem title={t('common:noOptions')} />
                )}
                {children}
            </Wrapper>
        );
    }
);

export default DropdownMenu;
